import styled from "styled-components";

export const HeaderContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 48px 48px 24px 48px;
    -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;

    ${({ $rightContent }) => !$rightContent && `
        align-items: center;
        justify-content: center;
    `}
`
export const LeftContent = styled.div`
    align-items: center;
    display: flex;
    gap: 16px;
    min-width: 0;

    img {
        cursor: pointer;
        flex-shrink: 0;
        height: 36px;
        transition: 0.3s ease-in-out;

        &:hover {
            transform: scale(1.025);
            transition: 0.3s ease-in-out;
        };
    };
`
export const RightContent = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
`